// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__213_s","content":"styles_content__3QFq4","row":"styles_row__3QVkN","footer":"styles_footer__r1j3W","phraseLength":"styles_phraseLength__BS1wY"};